import type { ApiResponse, ProgramDeletionCheckResponse } from '@fluenceur/types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

export const fetchProgramDeletionCheck = async (
  id: string
): Promise<ProgramDeletionCheckResponse> => {
  try {
    const response = await api.get<ApiResponse<ProgramDeletionCheckResponse>>(
      `/dashboard/programs/${id}/check-deletion`
    );

    console.log('fetchProgramDeletionCheck - API Response:', response.data);

    if (!response.data || !response.data.data) {
      throw new Error('Program deletion check failed or invalid response structure');
    }

    return response.data.data;
  } catch (error) {
    console.error('fetchProgramDeletionCheck - Error:', error);
    throw error;
  }
};

interface UseProgramDeletionCheckQueryProps {
  programId: string | undefined | null;
  enabled?: boolean;
}

const PROGRAM_DELETION_CHECK_QUERY_KEY_PREFIX = 'program-deletion-check';

export const useProgramDeletionCheckQuery = ({
  programId,
  enabled = true,
}: UseProgramDeletionCheckQueryProps): UseQueryResult<ProgramDeletionCheckResponse, Error> => {
  return useQuery<
    ProgramDeletionCheckResponse,
    Error,
    ProgramDeletionCheckResponse,
    [string, string | undefined | null]
  >({
    queryKey: [PROGRAM_DELETION_CHECK_QUERY_KEY_PREFIX, programId],
    queryFn: () => {
      if (!programId) {
        return Promise.reject(new Error('Program ID is required.'));
      }
      return fetchProgramDeletionCheck(programId);
    },
    enabled: !!programId && enabled,
    retry: 1,
    // Don't cache this data for too long as it could change
    staleTime: 0,
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
};
